import { connect } from 'react-redux'
import { FooterWidget } from '@blazar-plugins/footer'
import { isAppRoute } from 'routes/paths'
import { actionCreators as analyticsActions } from 'reduxBits/analytics'

const mapDispatchToProps = (dispatch) => ({
  trackFooterNavigation: (e, name) => {
    if (name) {
      dispatch(analyticsActions.trackFooterNavigation(name))
    }
  },
})

const mapStateToProps = () => ({ isAppRoute })

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FooterWidget)
